import { create } from "zustand";
import { AppSettingsState, AppSettingsActions } from "./types";
import { AppSettings } from "@/repository/models/app";
import { persist } from "zustand/middleware";
import { PersistentStorageKey } from "../common/persistentStorageKey";

export const useAppSettingsStore = create<AppSettingsState & AppSettingsActions>()(
	persist(
		(set, _) => ({
			settings: {} as AppSettings,
			timeDiference: 0,
			setSettings: (settings: AppSettings) => {
				const now = Date.now();
				const serverTime = Date.parse(settings.serverTime?.toString()) || now;

				set({
					settings: settings,
					timeDiference: serverTime - now,
				});
			},
		}),
		{
			name: PersistentStorageKey.AppSettings,
		}
	)
);

/**
 * Whether the tenant has at least one tag configured; drives whether the Tags column/detail is
 * offered anywhere in the client (CC4ALL-8822). False until settings load, so a surface never
 * offers the column before knowing the tenant supports it.
 */
export const useTagsExist = (): boolean =>
	useAppSettingsStore((state) => state.settings?.tagsExist ?? false);
